import { Component } from '@angular/core';

@Component({
    selector: 'fe-promotion-offer',
    templateUrl: './promotion-offer.component.html',
    styleUrls: ['./promotion-offer.component.scss'],
})
export class PromotionOfferComponent {
    public readonly offerHighlights = [
        {
            emoji: '🚗',
            title: 'fe_coupon_promotions_offer_1_title',
            text: 'fe_coupon_promotions_offer_1_text',
        },
        {
            emoji: '🗓️',
            title: 'fe_coupon_promotions_offer_2_title',
            text: 'fe_coupon_promotions_offer_2_text',
        },
        {
            emoji: '📍',
            title: 'fe_coupon_promotions_offer_3_title',
            text: 'fe_coupon_promotions_offer_3_text',
        },
        {
            emoji: '⚡',
            title: 'fe_coupon_promotions_offer_4_title',
            text: 'fe_coupon_promotions_offer_4_text',
        },
    ];
}
